import PointManager from "../PointManager/PointManager";
import AngleManager from "../AngleManager/AngleManager";
import LineManager from "../LineManager";
import { EventBus, EnumEventBus } from "../EventBus";
import { runAnimation } from "./SupplementaryAnimationSequence";


export default class SupplementaryAnimation {
  private EventBus = EventBus;
  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private LineManager: LineManager,
  ) {
  }
  runAnimation(isActive: boolean) {
    runAnimation(this, isActive, () => {
      this.EventBus.emit(EnumEventBus.supplementaryMode, isActive);
    })
  }
}